import {put, takeLatest, call} from 'redux-saga/effects';
import * as tableService from "../../../services/tableService.js";

import {
    SET_TAKEAWAY_TABLE,
    SET_TAKEAWAY_TABLE_SUCCESS,
    SET_TAKEAWAY_TABLE_ERROR,
}
    from "../../actions/table";

function* setTakeAwayTableSaga(action) {
    try {
        const data =  yield call(tableService.SetTakeAwayTable, action.payload)
        yield put({
            type: SET_TAKEAWAY_TABLE_SUCCESS,
            payload: data
        });
      


    } catch (error) {
        yield put({
            type: SET_TAKEAWAY_TABLE_ERROR,error: error.data
        });
    }
}


export function* setTakeAwayTableSagaWatcher() {
    yield takeLatest(SET_TAKEAWAY_TABLE, setTakeAwayTableSaga);
}